<div class="invoice-sku-discount-amount-form lum-modal">
  <form [formGroup]="form" (submit)="onSubmit()">
    <div class="lum-modal__header justify-space-between w-p100">
      <span class="lum-modal__header-title flex text-large">Discount Amount</span>
      <div class="lum-modal__header-close">
        <button
          type="button"
          class="lum-button lum-button--secondary"
          mat-button
          mat-dialog-close
        >
          <lum-ui-icon
            class="mr-2-5"
            icon="close-circle"
            color="#5563D6"
            width="23"
            height="23"
          ></lum-ui-icon>
          Close
        </button>
      </div>
    </div>

    <mat-dialog-content>
      <div class="form-group">
        <div class="lum-label">Discount Amount</div>
        <input
          type="number"
          class="lum-input"
          formControlName="discountAmount"
          placeholder="Discount Amount"
          matInput
          cdkFocusInitial
        />
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button
        type="button"
        class="lum-button lum-button--tertiary mr-2"
        mat-button
        mat-dialog-close
      >
        Cancel
      </button>
      <button mat-button type="submit" class="lum-button">Save</button>
    </mat-dialog-actions>
  </form>
</div>
